module.exports = __webpack_public_path__ + "chefy-cards-against-distance.png?3f4040ec2dfd7cfc5249a49201693e84";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-cards-against-distance.png
// module id = 35
// module chunks = 0